import { AxiosInstance, AxiosResponse } from 'axios';
import httpClient from '../httpClient';

export abstract class ApiClientBase {
  protected readonly api: AxiosInstance = httpClient;

  /**
   * Executes an API request with error handling
   */
  protected async asyncRunner<T>(requestFn: () => Promise<AxiosResponse<T>>): Promise<AxiosResponse<T>> {
    try {
      return await requestFn();
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('Unknown error occurred');
    }
  }

  protected isSuccessfulStatusCode(status: number): boolean {
    return status >= 200 && status < 300;
  }

  protected getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
      return error.message;
    }
    if (typeof error === 'object' && error !== null && 'message' in error) {
      return String(error.message);
    }
    return 'An unknown error occurred';
  }
}
